import { Common } from './common';
import {
  NoticeOfAdmission,
  NoticeOfAdmissionStatus,
  UpsertStatus,
} from './models/noticeOfAdmission';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOne(encounterId: string): Promise<NoticeOfAdmission> {
    const url = this.common.constructPath(`/notice-of-admission`, {
      encounterId,
    });
    return this.common.getJSON(url);
  }

  async upsert(
    encounterId: string,
    context: NoticeOfAdmission,
  ): Promise<NoticeOfAdmission> {
    const url = this.common.constructPath(`/notice-of-admission`);
    return this.common.putJSON(url, { encounterId, context });
  }

  async getStatus(
    encounterId: string,
  ): Promise<NoticeOfAdmissionStatus | undefined> {
    const url = this.common.constructPath(`/notice-of-admission/status`, {
      encounterId,
    });
    return this.common.getJSON(url);
  }

  async upsertStatus(
    args: UpsertStatus,
  ): Promise<NoticeOfAdmissionStatus | undefined> {
    const url = this.common.constructPath(`/notice-of-admission/status`);
    return this.common.putJSON(url, args);
  }

  async startExport(encounterId: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/notice-of-admission/export`);
    return this.common.postJSON(url, {
      encounterId,
      workflowHandling: 'REQUIRE',
    });
  }

  async startExtract(encounterId: string): Promise<{ success: true }> {
    const url = this.common.constructPath('/notice-of-admission/extract');
    return this.common.postJSON(url, {
      encounterId,
      workflowHandling: 'REQUIRE',
    });
  }
}
